import { PacketQuestion } from '../../types/packet.schema';
import { isBooleanArray } from '../../utils';
import { FileInputValue } from '../UseFileInput';
import { PacketFormFieldValue } from './useSellersPacketForm';

export const isFileInputField = (
  question: PacketQuestion,
  value?: PacketFormFieldValue
): value is FileInputValue[] => {
  if (question.htmlInputType !== 'file') {
    return false;
  }
  if (!Array.isArray(value)) {
    return false;
  }
  if (value.length === 0) {
    return true;
  }
  if (typeof value[0] !== 'object') {
    return false;
  }
  return 'url' in value[0] && 'file' in value[0];
};

export const isCheckboxGroupField = (
  question: PacketQuestion,
  value?: PacketFormFieldValue
): value is boolean[] =>
  ((question.htmlInputType === 'select' && question.multiple) || // Temporary solution for multi select
    question.htmlInputType === 'checkbox') &&
  isBooleanArray(value);

export const isDateField = (
  question: PacketQuestion,
  value?: PacketFormFieldValue
): value is Date | '' =>
  question.htmlInputType === 'date' &&
  // an empty string means an empty date field
  // DateInputs also currently have an 'optional' prop, so we need to handle null.
  (value instanceof Date || value === '' || value === null);

export const isTextBasedField = (
  question: PacketQuestion,
  value?: PacketFormFieldValue
): value is string =>
  [
    'radio',
    'select',
    'range',
    'text',
    'number',
    'email',
    'url',
    'tel',
    'a',
    'combobox'
  ].includes(question.htmlInputType) && typeof value === 'string';

export const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';
